import { EventEmitter, Output } from "@angular/core";
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import * as _ from "lodash";
import { forEach } from "lodash";
import moment from "moment";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";

@Component({
    selector: "timesheet-card",
    templateUrl: "./timesheet-card.component.html",
    standalone: false
})
export class TimesheetCardComponent implements OnChanges {
    constructor(private _eventBusService: EventBusService) {}

    @Input() batchSummary: any;
    @Input() buAccess: any;

    onDeleteTimesheet(item) {
        if (
            item.totalTimecards == 0 &&
            item.departmentId == this.buAccess.departmentId
        ) {
            this._eventBusService.emit(
                new EmitEvent("onDeleteTimesheet", "onDeleteTimesheet", item.id)
            );
        }
    }

    modifyDataSet(ds) {
        if (!ds) return;
        if (ds.createdDate)
            ds.createdDate = moment(ds.createdDate).format("DD MMM  YYYY");

        if (ds.audit && ds.audit.updateDate)
            ds.audit.updateDate = moment(ds.audit.updateDate).format(
                "DD MMM  YYYY"
            );

        return ds;
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === "batchSummary") {
                this.batchSummary = null;
                const ds = changes["batchSummary"]["currentValue"];
                this.batchSummary = this.modifyDataSet(ds);
            }
            if (propName === "buAccess") {
                this.buAccess = changes["buAccess"]["currentValue"];
            }
        }
    }
}
